import { reactive } from 'vue';

const chatLoading = reactive({
  isShow: false,
  show,
  close,
});

function show() {
  chatLoading.isShow = true;
}

function close() {
  chatLoading.isShow = false;
}

export default chatLoading;
